<template>
  <div class="employees">
    <!-- switch type search -->
    <h1 class="py-0 text-left mb-5">{{ this.$store.state.user_areas.users.titulo }}</h1>
    <h3 class="py-0 text-left mb-5">{{ this.$store.state.user_areas.users.total }} resultados</h3>
    <v-container>
      
      <v-row>

        <v-switch
          v-model="showFilters"
          label="Mostrar filtros"
          class="mt-0 mb-3"
          color="secondary"
          hide-details
        ></v-switch>
        <v-spacer></v-spacer>
        <v-btn class="mx-2" fab right color="secondary" small @click="reload">
          <v-icon> mdi-reload </v-icon>
        </v-btn>
        
        <v-btn class="mx-2" fab right color="success" small @click="generateCsv">
          <v-icon> mdi-file-excel </v-icon>
        </v-btn>
        
         <v-btn class="mx-2" fab right color="dark" small @click="addUser">
          <v-icon> mdi-plus </v-icon>
        </v-btn>
        
      </v-row>
    </v-container>

    <!-- Filters text search -->
    <v-card class="mb-2" v-if="showFilters">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="6" class="py-0">
            <v-text-field
              label="Filtre por cedula o nombre del colaborador"
              outlined
              hide-details
              dense
              append-icon="mdi-magnify"
              v-model="searchInput"
              clearable
              clear-icon="mdi-close-circle"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="2" class="py-0">
            <v-btn block color="secondary" @click="searchText"> Buscar </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Filters date and options search -->
    <v-card class="mb-2" v-if="showFilters">
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <VueCtkDateTimePicker
              color="DodgerBlue"
              v-model="datePiker.model"
              :label="datePiker.label"
              :range="true"
              :custom-shortcuts="datePiker.shortcut"
              :format="datePiker.format"
              :formatted="datePiker.formatted"
              inputSize="sm"
            />
          </v-col>
          <v-col cols="12" sm="12" md="3">
            <v-select
              outlined
              :items="this.$store.state.status.employeeStatus"
              label="Seleccione Estado"
              no-data-text="No hay registros..."
              hide-details
              dense
              v-model="filters.status"
            ></v-select>
          </v-col>     
          <v-col cols="12" sm="6" md="2">
            <v-btn block color="secondary" @click="searchFilters">
              Buscar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Table -->
    <v-card>      
      <v-data-table
        :headers="headers"
        :items="this.$store.state.user_areas.users.data"
        :search="search"
        hide-default-footer
        :items-per-page="20"
        :loading="this.$store.state.user_areas.isLoading"
        loading-text="Cargando... Por favor espere"
        no-data-text="No hay registro"
        no-results-text="Lo sentimos no hay registro para su busqueda, intente con otro"
      >
        <template v-slot:[`item.full_name`]="item">
          {{ item.item.user.full_name }}
        </template>
        <template v-slot:[`item.colombian_id`]="item">
          {{ item.item.user.colombian_id }}
        </template>
        <template v-slot:[`item.email`]="item">
          {{ item.item.user.email }}
        </template>
        <template v-slot:[`item.phone`]="item">
          {{ item.item.user.phone }}
        </template>
        <template v-slot:[`item.status`]="item">
          <v-chip :color="getEmployeeStatuColor(item.item.status)" dark small>
            {{ getEmployeeStatus(item.item.status) }}
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="item">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="show(item.item.id)"
              >
                mdi-eye-outline
              </v-icon>
            </template>
            <span>Ver</span>
          </v-tooltip>
          <v-tooltip
            bottom
            v-if="
              item.item.status == 'PENDING' ||
              item.item.status == 'INACTIVE' ||
              item.item.status == 'CORRECTION'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="green"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="updateStatus(item.item, 'ACTIVE', false, true)"
              >
                mdi-account-check
              </v-icon>
            </template>
            <span>Aceptar</span>
          </v-tooltip>
          <v-tooltip
            bottom
            v-if="item.item.status == 'PENDING' || item.item.status == 'ACTIVE'"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="orange"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="updateStatus(item.item, 'CORRECTION', true, false)"
              >
                mdi-account-alert
              </v-icon>
            </template>
            <span>Corregir</span>
          </v-tooltip>
          <v-tooltip
            bottom
            v-if="
              item.item.status == 'PENDING' ||
              item.item.status == 'CORRECTION' ||
              item.item.status == 'ACTIVE'
            "
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="updateStatus(item.item, 'INACTIVE', true, false)"
              >
                mdi-account-cancel
              </v-icon>
            </template>
            <span>Inactivar</span>
          </v-tooltip>
          
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="red"
                dark
                v-bind="attrs"
                v-on="on"
                @click="distroy(item.item)"
                class="px-1"
              >
                mdi-tag-remove-outline
              </v-icon>
            </template>
            <span>Quitar de esta area</span>
          </v-tooltip>
          
          <v-tooltip
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="green"
                dark
                v-bind="attrs"
                v-on="on"
                class="px-1"
                @click="moveArea(item.item)"
              >
                mdi-account-arrow-right
              </v-icon>
            </template>
            <span>Mover area</span>
          </v-tooltip>
          
          
          
        </template>
        

        
        
      </v-data-table>
      <v-col cols="12" sm="12" md="12">
        <v-pagination
          v-model="pagination.current"
          :length="pagination.total"
          :total-visible="8"
          circle
          @input="nextPage"
        ></v-pagination>
      </v-col>
    </v-card>

    <change-status
      :active.sync="activeChangeStatus"
      :payload="payload"
      :addNote="addNote"
      :addCharge="addCharge"
    ></change-status>

    <!-- delete dialog -->
    <v-dialog v-model="dialogDelete" width="500" persistent>
      <v-card>
        <v-card-text class="py-4">
          Seguro que desea quitar este colaborador del area?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            class="mr-4"
            @click="distroyConfirmation"
            small
          >
            Confirmar
          </v-btn>

          <v-btn color="error" text class="mr-4" @click="closeDistroy" small>
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    
      <!-- move dialog -->
    <v-dialog v-model="dialogMove" width="500" persistent>
      <v-card>
        <v-card-title class="py-4">
          Mover area
        </v-card-title>

	<v-col cols="12" md="12">
           <v-select
           v-model="selectedArea"
                  :items="this.$store.state.areas.areas.data"
	item-text="nombre"
      item-value="id"
                  :rules="[this.$store.state.rules.required]"
                  label="Area"
                  required
                ></v-select>
        </v-col>
        
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            class="mr-4"
            @click="distroyConfirmationArea"
            small
          >
            Confirmar
          </v-btn>

          <v-btn color="error" text class="mr-4" @click="closeDistroyArea" small>
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    
    <!-- add dialog -->
    <v-dialog v-model="dialogAdd" width="500" persistent>
      <v-card>
        <v-card-title class="py-4">
          Agregar colaborador
        </v-card-title>
 <v-container>
 <v-row align="center"
      justify="center">
 
	<v-col cols="10" md="10">
         <v-text-field
      v-model="queryUser"
      label="Buscar por nombre o identificacion"
      required
        :loading="this.$store.state.user_areas.isLoadingQuery"
    ></v-text-field>
        </v-col>
        
        <v-col cols="2" md="2">
          <v-btn
            color="success"
            @click="searchUser"
            small
          >
             <v-icon
                dark
                class="px-1"
                
              >
                mdi-account-search
              </v-icon>
          </v-btn>
        </v-col>
        
        
         </v-row>


<v-col cols="12" md="12" v-for="user in Qusers" :key="user.id">


 <v-container>
 <v-row align="left"
      justify="center">
   
   <v-col cols="10" md="10">   
   {{user.user.full_name}}
   </v-col>
   
    <v-col cols="2" md="2">   
 <v-btn
 class="ml-5"
            color="success"
            @click="addSelectUser(user)"
            small
          >
             <v-icon
                dark

                class="px-1"
                
              >
                mdi-plus
              </v-icon>
          </v-btn>     
   </v-col>
</v-row>
</v-container>

  
</v-col>

          </v-container>
        <v-divider></v-divider>




         <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="error" text class="mr-4" @click="closeDistroyAdd" small>
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    
  </div>
</template>

<script>
/* import { SET_ALERT } from "@/store/alert"; */
import { mapGetters } from "vuex";
import { SET_USERS_QUERY, SET_USERS } from "@/store/areas/users";
import { SET_ALERT } from "@/store/alert";
import ChangeStatus from "@/components/employee/ChangeStatus";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  name: "Area",
  components: {
    ChangeStatus,
    VueCtkDateTimePicker,
  },
  data: () => ({
    Qusers: {},
    search: "",
    showFilters: false,
    dialogDelete: false,
    dialogMove: false,
    dialogAdd: false,

    currentEmployee: null,
    searchInput: "",
    titulo: "",

    headers: [
      {
        text: "Nombre",
        align: "start",
        sortable: false,
        value: "full_name",
      },
      {
        text: "Identificación",
        value: "colombian_id",
        sortable: false,
      },
      { text: "Correo", value: "email", sortable: false },
      { text: "Teléfono", value: "phone", filterable: false, sortable: false },
      { text: "Estado", value: "status", filterable: false, sortable: false },
      {
        text: "Acciones",
        value: "actions",
        filterable: false,
        sortable: false,
      },
    ],
    filters: {
      status: "",    
      area: ""
    },
    pagination: {
      current: 0,
      total: 0,
    },
    payload: null,    
    activeChangeStatus: false,
    addNote: false,
    addCharge: false,
    selectedArea: false,
    queryUser: '',
  }),
  created() {
  this.filters.area = this.$route.params.id;


  
    this.$store.dispatch("getUsersArea");

      
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === SET_USERS) {
      
      console.log(this.$store.state)
      
        this.pagination.current =
          state.user_areas.users.current_page;
        this.pagination.total = state.user_areas.users.last_page;
      }

      
    });
  },
  computed: {
    ...mapGetters(["getEmployeeStatus", "getEmployeeStatuColor"]),
    datePiker(){      
      return this.$store.state.status.datePiker;
    }
  },
  methods: {
    show(id) {
      window.open(`/employees/show/${id}`, '_blank').focus();      
    },
    moveArea(user) {
    this.$store.dispatch("getAreas");
    this.currentEmployee = user;
    this.dialogMove = true;
    },
    addUser() {
    this.queryUser = '';
    this.dialogAdd = true;
    },
    addSelectUser(user) {

    this.currentEmployee = user;
    this.$store.dispatch("updateUserArea", {
        id: this.currentEmployee.id,
        form: {area: this.$route.params.id},
    });
    
     this.dialogAdd = false;
    },
    searchUser() {
    this.$store.dispatch("queryEmployee", this.queryUser);
    
    this.$store.subscribe((mutation) => {
    if (mutation.type === SET_USERS_QUERY) {
    this.Qusers = this.$store.state.user_areas.users_query.data;
    
    }
    });
        
    
    console.log("BUSCA")


    },
    generateCsv() {
    console.log("Genera un svg");
     this.$store.dispatch("downloadExcel");
     
    },
    nextPage() {
      this.$store.dispatch("nextPageEmployees");
    },
    updateStatus(item, status, note, charge) {
      this.payload = {
        id: item.id,
        form: {
          status: status,
          can_create_bill_without_report: "",
          _method: "put",
        },
      };
      this.addNote = note;
      this.addCharge = charge;
      this.activeChangeStatus = true;
    },
    distroy(user) {
      this.currentEmployee = user;
      this.dialogDelete = true;
    },
    distroyConfirmationArea() {

      this.$store.dispatch("updateUserArea", {
        id: this.currentEmployee.id,
        form: {area: this.selectedArea},
      });

      
      this.closeDistroyArea();
    },
    distroyConfirmation() {

      this.$store.dispatch("updateUserArea", {
        id: this.currentEmployee.id,
        form: {area: 0},
      });
      
      this.closeDistroy();
    },
    closeDistroy() {
      this.currentEmployee = null;
      this.dialogDelete = false;
    },
    closeDistroyAdd() {
      this.dialogAdd = false;
    },
    closeDistroyArea() {

      this.currentEmployee = null;
      this.dialogMove = false;
    },
    reload() {
      this.searchInput = "";
      this.filters = {
        status: "",
        area: ""    
      };
      this.datePiker.model = null;
      this.searchFiltersText = "area="+this.$route.params.id+"&";
      this.showFilters = false;
      this.$store.dispatch("getUsersArea");
    },
    searchText() {
      if (this.searchLoanInput == "") {
        this.$store.commit(SET_ALERT, {
          message: "Ingrese un valor de busqueda",
          type: "info",
        });
        return;
      }
      this.showFilters = false;
      this.$store.dispatch("getUsersArea", "search=" + this.searchInput + "&");
    },
    searchFilters() {
      this.searchFiltersText = "area="+this.$route.params.id+"&";

      if (this.datePiker.model !== null) {
        this.searchFiltersText =
          "min_date=" +
          this.datePiker.model.start +
          "&max_date=" +
          this.datePiker.model.end +
          "&";
      }      

      if (this.filters.status !== "") {
        this.searchFiltersText += "status=" + this.filters.status + "&";
      }      

      if (this.searchFiltersText == "") {
        this.$store.commit(SET_ALERT, {
          message: "Ingrese un valor de busqueda",
          type: "info",
        });
        return;
      }

      this.showFilters = false;
      this.$store.dispatch("getUsersArea", this.searchFiltersText);      
    },
  },
};
</script>
<style scoped>
.user {
  height: 100%;
}
.v-btn--bottom {
  bottom: 11px !important;
}
</style>
